import { render } from "./raceCreate.vue?vue&type=template&id=54aaa42e&scoped=true"
import script from "./raceCreate.vue?vue&type=script&lang=js"
export * from "./raceCreate.vue?vue&type=script&lang=js"

import "./raceCreate.vue?vue&type=style&index=0&id=54aaa42e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54aaa42e"]])

export default __exports__